import { gql } from '@apollo/client';
import type { TypedDocumentNode } from '@apollo/client';

import type { LiveChatChannelTrainingSessionsQuery, LiveChatQuery } from './liveChat.types';

export const EXTRANET_CHAT: TypedDocumentNode<LiveChatQuery> = gql`
  query liveChat {
    liveChat {
      token
      userSetting {
        emailReminderEnabled
      }
    }
  }
`;

export const LIVE_CHAT_CHANNEL_TRAINING_SESSIONS: TypedDocumentNode<LiveChatChannelTrainingSessionsQuery> = gql`
  query liveChatChannelTrainingSessions {
    liveChatChannelTrainingSessions {
      channelTrainingSessions {
        channelId
        trainingSessionId
        trainingSessionName
      }
    }
  }
`;

export const UPDATE_USER_SETTING = gql`
  mutation updateLiveChatUserSetting($setting: LiveChatUserSettingInput!) {
    updateLiveChatUserSetting(setting: $setting) {
      emailReminderEnabled
    }
  }
`;
